/**
 * UUID pattern for use in React Router path matching.
 * Matches standard UUID format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
 */
export const UUID_ROUTE_PATTERN = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

export const computeRepeatableNumberFromUUID = (id: Maybe<string>) => {
  // the first segment of the UUID
  return parseInt(id?.split('-')[0] || '0', 16);
};

export const isValidUuId = (id?: string | null): boolean => {
  if (!id) return false;
  const uuidRegex = /^(?:[0-9a-fA-F]{8}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{4}-?[0-9a-fA-F]{12})$/i;
  return uuidRegex.test(id);
};
